import {observer} from "mobx-react-lite";
import {ShippingLabelSettingsStore} from "../../../../stores/shipping-label-settings-store";
import {IValidationGroup} from "../../../../../../hooks/validation-group/validation-group-hook";
import {SelectDropdown} from "../../../../../../components/inputs/select-dropdown/select-dropdown";
import {FormFieldLine} from "../../../../../../components/form-field-line/form-field-line";
import React from "react";
import CheckboxesTreeDropdown from "../../../../../../components/inputs/checkboxes-tree-dropdown/checkboxes-tree-dropdown";

interface ICarrierSelectionOptionsFields {
    shippingLabelStore: ShippingLabelSettingsStore;
    validationGroup: IValidationGroup;

}

const CarrierSelectionOptionsFields: React.FC<ICarrierSelectionOptionsFields> = observer(({shippingLabelStore, validationGroup}) => {

    const carrierSelectionStore = shippingLabelStore?.carrierSelectionOptionsStore;

    if(!carrierSelectionStore) {
        return null;
    }

    return (
        <>
            <FormFieldLine
                label="Carrier & Service Level"
                note="Configure your preferred shipping carriers and service levels. You can customize specific carriers and service levels, or set it to all available options."
            >
                <CheckboxesTreeDropdown
                    compressed={true}
                    options={carrierSelectionStore.getCarrierSelectionOptions()}
                    value={carrierSelectionStore.getSelectedCarriers()}
                    onChange={v => carrierSelectionStore.setCarriers(v)}
                    checkboxesSelectAllText="Select all"
                    isCheckboxesListDisabled={carrierSelectionStore.isLoading()}
                    searchInputPlaceholder="Search by carrier names"
                />
            </FormFieldLine>

            <FormFieldLine
                label="Auto-Selection Type"
                note="Choose the criteria by which the carrier and service level will be automatically selected."
            >
                <SelectDropdown
                    value={carrierSelectionStore.getAutoSelectionTypeSelectedValue()}
                    options={carrierSelectionStore.getAutoSelectionTypeOptions() ?? []}
                    onChange={(v) => {
                        carrierSelectionStore.setAutoSelectionTypeValue(v)
                    }}
                    validationGroup={validationGroup}
                    isLoading={carrierSelectionStore.isLoading()}
                    required={true}
                />
            </FormFieldLine>

        </>
    )
});

export default CarrierSelectionOptionsFields;